import { Routes } from '@angular/router';

/**
 * Production stub for dev-routes.ts (swapped in via angular.json
 * fileReplacements for the semiproduction/production configurations).
 *
 * MUST stay empty and MUST NOT import anything from `src/app/dev-app-shell/`
 * — that is what guarantees the dev launcher and its secrets are excluded
 * from the deployed bundle.
 */
export const devRoutes: Routes = [];
